import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronDown } from 'lucide-react';
import { getWishist, getCartist, getTagList, getProducts, getSubCategoryByCategory } from '../../redux/services/productService';
import './SearchHeader.css';
import { useRef } from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import { AiOutlineShopping } from 'react-icons/ai';

const ALL_PRODUCTS_NODE = {
  Id: 0,
  Name: "ALL PRODUCTS",
  ProductCount: 0,
  subcategories: [],
};

const SearchHeader = ({ cartwishlistCount = {CartCount:0,WishlistCount:0,CartAmount:0},selectedCategory = null, selectedMainCategory = null, onCategoryChange=() => {}, onSearch, initialQuery = "", cartTrigger = 0, wishlistTrigger = 0, onCartUpdate,otherScreens=false }) => {
  const [wishlistCount, setWishlistCount] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const [cartAmount, setCartAmount] = useState(0.0);
  const [query, setQuery] = useState(initialQuery);
  const [dropdownValue, setDropdownValue] = useState("default");
  const [categories, setCategories] = useState([]);
  const [allcategories, setAllCategories] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showCategoryTree, setShowCategoryTree] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({});
  
  let typingTimer = null;
  
  const navigate = useNavigate();
  const searchBoxRef = useRef(null);
const debounceRef = useRef(null);
const treeRef = useRef(null);
const location = useLocation();
const lastSegment = location.pathname.split("/").filter(Boolean).pop();

useEffect(() => {
  function handleClickOutside(event) {
    if (treeRef.current && !treeRef.current.contains(event.target)) {
      setShowCategoryTree(false);
    }
  }
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

const toggleCategoryExpand = (id) => {
  setExpandedCategories(prev => ({ ...prev, [id]: !prev[id] }));
};
const handleCategorySelectTree = (node) => {
  setDropdownValue(node.Id.toString());
  onCategoryChange(node);
  setShowCategoryTree(false);
  if (location.pathname !== "/shop") {
    navigate("/shop", {
      state: {
        query,
        category: node
      }
    });
  }
  
};

// Replace your current TreeNode with this
const TreeNode = ({ node, depth = 0 }) => {
  const hasChildren = Array.isArray(node.subcategories) && node.subcategories.length > 0;
  const isExpanded = !!expandedCategories[node.Id];

  const onToggle = (e) => {
    e.stopPropagation();
    toggleCategoryExpand(node.Id);
  };

  const onRadioChange = (e) => {
    e.stopPropagation();
    handleCategorySelectTree(node);
  };

  return (
    <div className="tree-node" style={{ paddingLeft: depth * 18 + "px" }}>
      <div className="tree-node-row">
        <label
          className="tree-node-label"
          onClick={(e) => {
            e.stopPropagation();
            handleCategorySelectTree(node);
          }}
        >
          <input
            className="category-radio"
            type="radio"
            name="category-tree"
            checked={Number(dropdownValue) === node.Id}
            onChange={onRadioChange}
          />
          <span className="node-name">{node.Name}</span>
        </label>

        <div className="node-right">
          {/* <span className="node-count">{node.ProductCount ?? 0}</span> */}

          {hasChildren ? (
            <button
              className={`tree-toggle ${isExpanded ? "expanded" : ""}`}
              onClick={onToggle}
              aria-label={isExpanded ? "Collapse" : "Expand"}
            >
              {isExpanded ? (
                // prefer same icon look as SideFilter
                <KeyboardArrowUp sx={{ fontSize: 14 }} />
              ) : (
                <KeyboardArrowDown sx={{ fontSize: 14 }} />
              )}
            </button>
          ) : (
            <span className="tree-toggle-placeholder" />
          )}
        </div>
      </div>

      {isExpanded && hasChildren && (
        <div className="tree-children">
          {node.subcategories.map((child) => (
            <TreeNode key={child.Id} node={child} depth={depth + 1} />
          ))}
        </div>
      )}
    </div>
  );
};





  const fetchSuggestions = async (value) => {
  if (!value || value.length < 2) {
    setSuggestions([]);
    return;
  }

  try {
    const res = await getProducts({
      search: value,
      pageSize: 20,
    });

    if (res.status === "Success") {
      const parsed = JSON.parse(res.result);
      setSuggestions(parsed?.Data || parsed || []);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
    }
  } catch (err) {
    console.error("Search error:", err);
    setSuggestions([]);
  }
};


  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

// Convert to recursive tree with subcategories property
const convertApiSubcats = useCallback((items) => {
  if (!Array.isArray(items)) return [];
  return items.map((it) => ({
    Id: it.Id,
    Name: it.Name,
    ProductCount: it.ProductCount ?? 0,
    // Only take 1st level children, do NOT recurse further
    subcategories: (it.SubCategories || []).map(sub => ({
      Id: sub.Id,
      Name: sub.Name,
      ProductCount: sub.ProductCount ?? 0,
      subcategories: [] // force stop deeper levels
    }))
  }));
}, []);
  const convertApiSubcatsAll = useCallback((items) => {
    if (!Array.isArray(items)) return [];
    return items.map((it) => ({
      Id: it.Id,
      Name: it.Name,
      ProductCount: it.ProductCount ?? 0,
      // Keep original SubCategories key mapping to our subcategories property
      subcategories: convertApiSubcats(it.SubCategories || [])
    }));
  }, []);
const findCategoryNode = useCallback((id) => {
  if (!id || id === "default") return null;
  const numId = Number(id);

  // Level 1 search
  for (const cat of allcategories) {
    if (cat.Id === numId) return cat;

    // Level 2 search
    const sub = cat.subcategories?.find(s => s.Id === numId);
    if (sub) return sub;
  }
  return null;
}, [allcategories]);


const parseSubcategoriesFromResponse = useCallback((res) => {
  try {
    if (!res) return [];
    const parsed1 = typeof res.result === "string" ? JSON.parse(res.result) : res.result;
    const maybeData = parsed1?.[0]?.data;
    if (!maybeData) return [];
    const parsed2 = typeof maybeData === "string" ? JSON.parse(maybeData) : maybeData;
    setAllCategories(convertApiSubcatsAll(parsed2 || []))
    return convertApiSubcats(parsed2 || []);
  } catch (err) {
    console.error("Failed to parse categories:", err);
    return [];
  }
}, [convertApiSubcats]);

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await getSubCategoryByCategory(0);
      const parsed = parseSubcategoriesFromResponse(res);
      
      
      setCategories([ALL_PRODUCTS_NODE, ...parsed]);
    } catch (err) {
      console.error("Error fetching category tree:", err);
      setCategories([]);
    }
  };
  fetchCategories();
}, [parseSubcategoriesFromResponse]);
  // Update dropdown value when selectedCategory or selectedMainCategory changes
useEffect(() => {
 // Case 1: no category selected → reset to default
  if (!selectedCategory) {
    setDropdownValue("default");
    return;
  }

  // Case 2: categories not yet loaded → wait (don’t reset)
  if (!allcategories.length) return;

  // Case 3: both available → set proper category ID
  setDropdownValue(selectedCategory.Id.toString());
}, [selectedCategory, allcategories]);

const getCategoryNameById = (id) => {
  const node = findCategoryNode(id);
  return node ? node.Name : "Select Category";
};


  // const fetchCartData = useCallback(async () => {
  //   try {
  //     const res = await getCartist();
  //     const parsedData = JSON.parse(res?.result);
  //     const cartItems = parsedData?.Data || [];
  //     const totalQuantity = cartItems.reduce((sum, item) => sum + (item.Quantity || 1), 0);
  //     setCartCount(cartItems.length);
  //     const totalAmount = cartItems.reduce((sum, item) => sum + (item.Rate || 0) * (item.Quantity || 1), 0) || 0;
  //     setCartAmount(totalAmount);
  //   } catch (error) {
  //     console.error("Error fetching cart:", error);
  //   }
  // }, []);

  // useEffect(() => {
  //   const fetchWishlist = async () => {
  //     try {
  //       const res = await getWishist();
  //       const parsedData = JSON.parse(res.result);
  //       setWishlistCount(parsedData.Data?.length || 0);
  //     } catch (error) {
  //       console.error("Error fetching wishlist:", error);
  //     }
  //   };

  //   fetchWishlist();
  // }, [wishlistTrigger]);

  // useEffect(() => {
  //   fetchCartData();
  // }, [cartTrigger]);

  // Expose fetchCartData to parent components
  // useEffect(() => {
  //   if (onCartUpdate) {
  //     onCartUpdate(fetchCartData);
  //   }
  // }, [onCartUpdate, fetchCartData]);

  const handleSearch = () => {
    navigate("/shop", {
      state: {
        query,
        category: selectedCategory || selectedMainCategory,
      },
    });

    if (onSearch) {
      onSearch(query);
    }
  };

 const handleCategoryChange = (e) => {
  const selectedId = e.target.value;
  if (selectedId === "default") {
    onCategoryChange(null);
    return;
  }

  const node = findCategoryNode(selectedId);
  onCategoryChange(node);

  if (otherScreens) {
    navigate("/shop", {
      state: { query, category: node },
    });
  }
};

  useEffect(() => {
  const handleClickOutside = (e) => {
    if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
      setShowSuggestions(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  return (
    <header className="search-header" >
      <div className="header-container" >
        {/* Logo Section */}
        <div className="logo-section">
          <img
            src={"./Images/logopageimg.jpg"}
            alt="Company Logo"
            className="header-logo"
          />
        </div>

        {/* Search Section */}
        <div className="search-section">
          <div className="search-container search-relative" ref={searchBoxRef}>
            <input
              type="text"
              className="search-input"
              placeholder="Search for products"
              value={query}
              onChange={(e) => {
                const value = e.target.value;
                setQuery(value);
                clearTimeout(debounceRef.current);
                debounceRef.current = setTimeout(() => fetchSuggestions(value), 300);
              }}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
           <div className="category-dropdown-tree" ref={treeRef}>
  <div 
    className="dropdown-trigger" 
    onClick={() => setShowCategoryTree((prev) => !prev)}
  >
   {getCategoryNameById(dropdownValue)}

    <ChevronDown size={15} />
  </div>

  {showCategoryTree && (
    <div className="searcheader-category-item">
      {categories.map(cat => (
        <TreeNode key={cat.Id} node={cat} />
      ))}
    </div>
  )}
</div>

            <button className="search-button" onClick={handleSearch}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </button>

            {showSuggestions && suggestions.length > 0 && (
    <div className="search-suggestion-box">
      {suggestions.map((item, idx) => (
        <div
          key={idx}
          className="suggestion-item"
          onClick={() => {
            navigate("/view", { state: { product: item ,from: lastSegment} });
            setShowSuggestions(false);
          }}
        >
          <img src={item.Image} alt="" className="suggestion-thumb" />
          <div className="suggestion-info">
            <div className="suggestion-name">{item.Name}</div>
            <div className="suggestion-sub">SKU: {item.Code}</div>
            <div className="suggestion-price">{(item?.Rate ?? 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} AED</div>
          </div>
        </div>
      ))}
    </div>
  )}
            
          </div>
        </div>

        {/* Right Section */}
        <div className="right-section">
          <button className="wishlist-btn" onClick={(e) => { e.preventDefault(); navigate('/wishlist'); }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
            <span className="cart-badgeHeader">{cartwishlistCount?.WishlistCount >999 ?"999+":cartwishlistCount?.WishlistCount}</span>
          </button>

          <button className="cart-btn" onClick={(e) => { e.preventDefault(); navigate('/cart'); }}>
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg> */}
            <AiOutlineShopping  size={24} />
            <span className="cart-badgeHeader">{cartwishlistCount?.CartCount >999 ?"999+":cartwishlistCount?.CartCount}</span>
          </button>

          <div className="cart-price">{(cartwishlistCount?.CartAmount??0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED</div>

          <button className="account-btn" onClick={(e) => { e.preventDefault(); navigate('/account'); }} style={{fontWeight:600}}>MY ACCOUNT</button>
        </div>
      </div>
       
    </header>
  );
};

export default SearchHeader;